<template>
  <button
    class="border border-grey-9 text-sm bg-grey-1 px-2 py-1 rounded hover:bg-grey-2 transition-colors transition-250 | button"
    :class="typeClass"
    :type="nativeType"
    @click="$emit('click')"
    :disabled="disabled"
  >
    <span class="inline-block mx-1 h-full" style="margin-bottom: -0.1rem;" v-if="this.$slots.icon">
      <slot name="icon"></slot>
    </span>
    <span class="inline-block" :class="{'mr-1': this.$slots.icon}">
      <slot class="inline-block"></slot>
    </span>
  </button>
</template>

<script>
export default {
  name: "Button",
  props: {
    nativeType: {
      default: "button"
    },
    type: {
      default: "primary"
    },
    disabled: {
      default: false
    }
  },
  computed: {
    typeClass() {
      if (this.type === "secondary")
        return "text-yellow-8 hover:text-yellow-7 hover:border-yellow-7"
      if (this.type === "success")
        return "text-green-8 hover:text-green-7 hover:border-green-7"
      if (this.type === "danger")
        return "text-red-8 hover:text-red-7 hover:border-red-7"
      return "text-blue-8 hover:text-blue-7 hover:border-blue-7"
    }
  }
}
</script>

<style lang="scss">
.button[disabled] {
  @apply cursor-not-allowed opacity-50;
}
</style>
